import Section from '../components/Section';
import EmailCaptureForm from '../components/EmailCaptureForm';
import { useLanguage } from '../context/LanguageContext';

export default function Join() {
  const { t } = useLanguage();
  const benefits = [t('join.benefit1'), t('join.benefit2'), t('join.benefit3')];

  return (
    <Section>
      <div className="callout" style={{ maxWidth: 720, margin: '0 auto' }}>
        <span className="hero__pill">◐ {t('hero.pill')}</span>
        <h1 style={{ fontSize: 'var(--fs-h2)', marginTop: '1rem' }}>{t('join.title')}</h1>
        <p className="section__lead">{t('join.lead')}</p>

        <ul style={{ listStyle: 'none', padding: 0, margin: '1.5rem 0' }}>
          {benefits.map((b) => (
            <li key={b} style={{ display: 'flex', gap: '0.6rem', margin: '0.6rem 0', color: 'var(--ink-soft)' }}>
              <span style={{ color: 'var(--accent-strong)', fontWeight: 700 }}>✓</span> {b}
            </li>
          ))}
        </ul>

        <div style={{ maxWidth: 440 }}>
          <EmailCaptureForm source="join-page" buttonLabel={t('cta.join')} />
        </div>
        <p className="hero__trustline">{t('hero.trustline')}</p>
      </div>
    </Section>
  );
}
